import { apiConstants } from '../config';
let code = apiConstants.code;
let codeAPI = apiConstants.codeAPI;
const state = {
    error: null,
    loading: false,
    data: {
        code: code,
        codeAPI: codeAPI,
        module: {},
        panels: {
            home: {
                acl: {
                    view: 'IG_00001',
                },
                url: {
                },
            },
            headernav: {
                tools: [
                    {component: 'dashboard', title: 'dashboard.title'},
                ]
            },
        },
        tools: {
            backoffice: {
                active: true,
                title: 'backoffice.title',
                label: 'backoffice.label',
                panel: {
                    show: false,
                },
                acl: {
                    view: 'IG_00006',
                },
                url: {
                    view: `{moduleCode}gestao.home`
                }
            },
            layerswitcher: {
                acl: {
                    view: 'IG_00009',
                },
            },
            streetview: {
                acl: {
                    view: 'IG_00008',
                },
            },
            annotations: {
                acl: {
                    view: 'IG_00005',
                },
            },
            layers: {
                active: true,
                title: 'layers.title',
                label: 'layers.label',
                panel: {
                    show: false,
                    loaded: false,
                },
                acl: {
                    view: 'IG_00002',
                },
                url: {
                    getLayers: `${codeAPI}/front/map/layers`,
                },
            },
            dashboard: {
                active: true,
                panel: {
                    show: false,
                    loaded: false,
                },
                acl: {
                    view: 'IG_00007',
                },
            },
            navsearch: {
                active: true,
                panel: {
                    show: true,
                    showDefault: true,
                    categories: [{
                        'id': 'addr',
                        'name': 'navsearch.address.title',
                        'url': '../gateway/address/search',
                        'listGroup': 'adminName1',
                        'labelTemplate': 'navsearch.address.labelTemplate',
                        'subLabelTemplate': null,
                        'placeholder': 'navsearch.address.placeholder'
                    }],
                    search: {
                        category: null,
                        item: null,
                        search: null,
                    },
                },
                acl: {
                    view: null,
                },
            },
            catalog: {
                acl: {
                    view: 'IG_00011',
                },
            },
            identify: {
                acl: {
                    view: 'IG_00012',
                },
            },
            print_visible_emissions: {
                active: true,
                title: 'print_visible_emissions.titles',
                label: 'print_visible_emissions.label',
                panel: {
                    show: false,
                    loaded: false,
                },
                acl: {
                    view: 'IG_00010',
                },
                url: {
                    capabilitiesPrint: `${codeAPI}/front/print/visible/capabilities`,
                    createPrint: `${codeAPI}/front/print/visible`,
                    getStatusPrint: `${codeAPI}/front/print/visible/job/:id`,
                }
            },
            schooldistance: {
                active: true,
                title: 'Distância Casa / Escola',
                label: 'Subsídios',
                panel: {
                    show: false,
                    loaded: false,
                },
                acl: {
                    view: 'SE_00003',
                    export: 'SE_00004',
                },
                url: {
                    addressFromPosition: `/subsidioescolar/address/search/position/:lng/:lat`,
                    address: `/subsidioescolar/address/search?q=:query`,
                    schoolFromPosition: `/subsidioescolar/school/search/position/:lng/:lat`,
                    school: `/subsidioescolar/school/search?q=:query`,
                    route: `/subsidioescolar/route`,
                    status: `/subsidioescolar/route/job/:id`,
                }
            },
        },
        map: {
            loading: false,
            action: null,
            config: {
            }
        },
        config: {

        },
    },
};

export default state;